import { where, documentId } from 'firebase/firestore';
import {
  fetchByTable,
  addDataToTable,
  updateDataById,
  deleteDocById,
  delay,
} from '../utils';

export const fetchLeagues = async setLoading =>
  fetchByTable({ tableName: 'leagues', orderByField: 'startDate', setLoading });

export const addLeague = async (data, setLoading) =>
  addDataToTable({ tableName: 'leagues', data, setLoading });

export const updateLeague = async (id, data, setLoading) =>
  updateDataById({ id, tableName: 'leagues', data, setLoading });

export const removeLeague = async (id, setLoading) =>
  deleteDocById({ tableName: 'leagues', id, setLoading });
